import { useBreakpoints } from '../../../../../../bookings/util/useBreakpoints';
import {
  Maybe,
  Rating as RatingType,
  RatingDisabledReason,
} from '../../../../../../common/schema/hannibal/types.generated';
import {
  Description,
  Detail,
  RatingWrapper,
  ThumbTeal,
  View,
  RatingText,
  NoWrapDetails,
} from './Rating.styles';
import { ratingRound } from './ratingRound';

interface Props {
  readonly rating?: Maybe<RatingType>;
}

export const Rating = ({ rating }: Props) => {
  const breakpoints = useBreakpoints();

  if (!rating) {
    return null;
  }

  const { disabled, disabledReason, count } = rating;
  const optedOut = disabledReason === RatingDisabledReason.PracticeOptOut;
  const tooFew = disabledReason === RatingDisabledReason.NotEnoughRatings;
  const noRatings = disabledReason === RatingDisabledReason.NoRatings;

  // Invalid data combination - render nothing
  if (disabled && !optedOut && !tooFew) {
    return null;
  }

  // tooFew: render nothing as per BLOB-125 Temp bridging ratings calculation algorithm
  if (tooFew) {
    return null;
  }

  if (optedOut) {
    return (
      <View>
        <NoWrapDetails>This practice has chosen not to be rated on Healthengine</NoWrapDetails>
      </View>
    );
  }

  if (noRatings) {
    return (
      <View tooFew>
        <Detail>No patients have rated this practice in the past 12 months</Detail>
      </View>
    );
  }

  const detail = tooFew
    ? 'Must have 10 reviews in the past 12 months'
    : `${count} ratings in the past 12 months`;

  const text = breakpoints.Small
    ? `Recommended by ${ratingRound(rating.rating)}% of patients.`
    : `of patients recommend this practice.`;

  return (
    <View>
      <RatingWrapper>
        <ThumbTeal />
        <RatingText>{ratingRound(rating.rating)}%</RatingText>
      </RatingWrapper>
      <Description>
        {text} {detail}
      </Description>
    </View>
  );
};
